<template>
  <div>
    <div class="back-top-box">
      <div class="back-top" id="back-to-top" @click="backTop">
        <img src="~@/assets/img/ico_zhiding.png" alt="" />
        <p>返回顶部</p>
      </div>
      <div class="tfriend-invitation" @click="friendInvitation">
        <img src="~@/assets/img/jump-friends.png" alt="" />
        <p>好友邀请</p>
      </div>
      <div class="to-ke-fu" @click="toKefu">
        <img src="~@/assets/img/ico_kf.png" alt="" />
        <p>联系客服</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scrollTop: 0
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
    },
    backTop() {
      let timer;
      let _this = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (_this.scrollTop > 0) {
          _this.scrollTop -= 50;
          document.body.scrollTop = document.documentElement.scrollTop =
            _this.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
        }
      });
    },
    toKefu() {
      // window.open('https://wpa1.qq.com/4yUujyQF?_type=wpa&qidian=true')
      window.open("https://wpa1.qq.com/EAq4arcw?_type=wpa&qidian=true");
    },
    friendInvitation() {
      window.open("/attract/");
    }
  }
};
</script>

<style scoped>
.back-top-box {
  width: 80px;
  height: 270px;
  background-color: #fff;
  position: fixed;
  right: 10px;
  box-sizing: border-box;
  bottom: 20px;
  padding: 0 5px;
  border-radius: 5px;
  line-height: 0 !important;
  box-shadow: 0px 0px 2.2px rgba(0, 0, 0, 0.028),
    0px 0px 5.3px rgba(0, 0, 0, 0.04), 0px 0px 10px rgba(0, 0, 0, 0.05),
    0px 0px 17.9px rgba(0, 0, 0, 0.06), 0px 0px 33.4px rgba(0, 0, 0, 0.072),
    0px 0px 80px rgba(0, 0, 0, 0.1);
}

.back-top-box .back-top,
.back-top-box .to-ke-fu,
.tfriend-invitation {
  width: 100%;
  height: 90px;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  padding: 15px 0;
  user-select: none;
}

.back-top-box .back-top,
.back-top-box .tfriend-invitation {
  border-bottom: 1px dashed #ccc;
}

.back-top-box .to-ke-fu img,
.back-top-box .back-top img,
.back-top-box .tfriend-invitation img {
  width: 40px;
  height: 40px;
  -webkit-user-drag: none;
}

.back-top-box .to-ke-fu p,
.back-top-box .back-top p,
.back-top-box .tfriend-invitation p {
  font-size: 12px;
  margin-top: 15px;
  line-height: 0;
}

.back-top-box .back-top,
.to-ke-fu p,
.tfriend-invitation p {
  color: #6a6a6d;
}

@media screen and (max-width: 420px) {
  .back-top-box {
    width: 60px;
    height: 210px;
    right: 10px;
    bottom: 10px;
  }
  .back-top-box .to-ke-fu img,
  .back-top-box .back-top img,
  .back-top-box .tfriend-invitation img {
    width: 30px;
    height: 30px;
    -webkit-user-drag: none;
  }
  .back-top-box .back-top,
  .back-top-box .to-ke-fu,
  .back-top-box .tfriend-invitation {
    height: 70px;
    padding: 10px 0;
  }
  .back-top-box .to-ke-fu p,
  .back-top-box .back-top p,
  .back-top-box .tfriend-invitation p {
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Side/BackTop.vue